import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29ad319a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-body msg_card_body",
  ref: "messagesContainer"
}
const _hoisted_2 = {
  key: 0,
  class: "message-wrapper user-message"
}
const _hoisted_3 = { class: "msg_cotainer_send" }
const _hoisted_4 = { class: "img_cont_msg" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "message-wrapper bot-message"
}
const _hoisted_7 = { class: "img_cont_msg" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "msg_cotainer" }
const _hoisted_10 = {
  key: 0,
  class: "typing-indicator"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.messages, (message) => {
      return (_openBlock(), _createElementBlock("div", {
        key: message.id
      }, [
        (message.role === 'user')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(message.text), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: $options.userAvatarSrc(),
                  class: "rounded-circle user_img_msg"
                }, null, 8, _hoisted_5)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: $options.botAvatarSrc(),
                  class: "rounded-circle user_img_msg"
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(message.text), 1)
            ]))
      ]))
    }), 128)),
    ($data.showTyping)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
      : _createCommentVNode("", true)
  ], 512))
}